













































































































































































































































import {Component} from "vue-property-decorator";
import {SiteStore} from "@/modules/sites/store";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import SiteSearch from "@/modules/sites/List/components/Search.vue";
import SiteTableAction from "@/modules/sites/List/components/TableAction.vue";
import ProvinceLabel from "@/modules/regions/ProvinceLabel/index.vue";
import DistrictLabel from "@/modules/regions/DistrictLabel/index.vue";
// import WardLabel from "@/modules/regions/WardLabel/index.vue";
import PostOfficeLabel from "@/modules/postoffices/List/components/Label.vue";
import EmployeeLabel from "@/modules/employees/List/components/Label.vue";
import CountryLabel from "@/modules/regions/CountryLabel/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {EmployeeType, PartnerType, SiteTargetType} from "@/enums/type";
import {SiteParams} from "@/modules/sites/params";
import {Site} from "@/interfaces/entity";
import CountrySelector from "@/modules/regions/CountrySelector/index.vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
// import WardSelector from "@/modules/regions/WardSelector/index.vue";
import {AuthStore} from "@/modules/auth/store";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import UploadDocument from "@/shared/components/UploadDocument/Index.vue";
import {listSite, uploadSite} from "@/modules/sites/services";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import SiteExcel from "@/modules/sites/List/components/Excel/index.vue";
import XLSX from "xlsx";
import {openDownloadDialog, sheet2blob} from "@/shared/services/helper/utils";

const columns = [
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        scopedSlots: { customRender: 'action' },
        width: 100,
        align: "center",
        fixed: 'left'
    },
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 50
    },
    {
        title: "Nước",
        dataIndex: "countryId",
        key: "countryId",
        scopedSlots: { customRender: "country" },
        width: 150,
        ellipsis: true
    },
    {
        title: "Mã tỉnh",
        dataIndex: "province.code",
        key: "provinceCode",
        width: 70,
        ellipsis: true
    },
    {
        title: "Tỉnh",
        dataIndex: "provinceId",
        key: "provinceId",
        scopedSlots: { customRender: "province" },
        width: 150,
        ellipsis: true
    },
    {
        title: "Mã phường/xã",
        dataIndex: "district.code",
        key: "districtCode",
        width: 150,
        ellipsis: true
    },
    {
        title: "Phường/xã",
        dataIndex: "districtId",
        key: "districtId",
        scopedSlots: { customRender: "district" },
        width: 180,
        ellipsis: true
    },
    {
      title: "Mã tính cuớc",
      dataIndex: "freightFeeCode",
      key: "freightFeeCode",
      width: 150,
      ellipsis: true
    },
    // {
    //     title: "Phường/xã",
    //     dataIndex: "wardId",
    //     key: "wardId",
    //     scopedSlots: { customRender: "ward" },
    //     width: 200,
    //     ellipsis: true
    // },
    {
        title: "Bưu cục nhận",
        dataIndex: "receivePostOfficeRowGuid",
        key: "receivePostOfficeRowGuid",
        scopedSlots: { customRender: "receivePostOffice" },
        width: 200
    },
    {
        title: "Shipper/Đối tác nhận",
        dataIndex: "receiveTargetRowGuid",
        key: "receiveTargetRowGuid",
        scopedSlots: { customRender: "receiveTarget" },
        width: 300
    },
    {
        title: "Bưu cục phát",
        dataIndex: "deliveryPostOfficeRowGuid",
        key: "deliveryPostOfficeRowGuid",
        scopedSlots: { customRender: "deliveryPostOffice" },
        width: 200
    },
    {
        title: "Shipper/Đối tác phát",
        dataIndex: "deliveryTargetRowGuid",
        key: "deliveryTargetRowGuid",
        scopedSlots: { customRender: "deliveryTarget" },
        width: 300
    },
    {
        title: "Ghi chú",
        dataIndex: "note",
        key: "note",
        scopedSlots: { customRender: "note" },
        width: 200
    },
    {
        title: "Ghi chú KH",
        dataIndex: "customerNote",
        key: "customerNote",
        scopedSlots: { customRender: "customerNote" },
        width: 200
    },
    {
        title: "HSVX",
        dataIndex: "regionFar",
        key: "regionFar",
        scopedSlots: { customRender: "regionFar" },
        width: 100
    },
    {
        title: "TL chính(g)(PCG)",
        dataIndex: "weightDeliveryMain",
        key: "weightDeliveryMain",
        scopedSlots: { customRender: "weightDeliveryMain" },
        width: 150
    },
    {
        title: "Phí chính(PCG)",
        dataIndex: "feeDeliveryMain",
        key: "feeDeliveryMain",
        scopedSlots: { customRender: "feeDeliveryMain" },
        width: 150
    },
    {
        title: "TL cộng thêm(g)(PCG)",
        dataIndex: "weightDeliveryPlus",
        key: "weightDeliveryPlus",
        scopedSlots: { customRender: "weightDeliveryPlus" },
        width: 160
    },
    {
        title: "Phí cộng thêm(PCG)",
        dataIndex: "feeDeliveryPlus",
        key: "feeDeliveryPlus",
        scopedSlots: { customRender: "feeDeliveryPlus" },
        width: 150
    },
    {
        title: "TL chính(g)(PCN)",
        dataIndex: "weightReceiveMain",
        key: "weightReceiveMain",
        scopedSlots: { customRender: "weightReceiveMain" },
        width: 150
    },
    {
        title: "Phí chính(PCN)",
        dataIndex: "feeReceiveMain",
        key: "feeReceiveMain",
        scopedSlots: { customRender: "feeReceiveMain" },
        width: 150
    },
    {
        title: "TL cộng thêm(g)(PCN)",
        dataIndex: "weightReceivePlus",
        key: "weightReceivePlus",
        scopedSlots: { customRender: "weightReceivePlus" },
        width: 160
    },
    {
        title: "Phí cộng thêm(PCN)",
        dataIndex: "feeReceivePlus",
        key: "feeReceivePlus",
        scopedSlots: { customRender: "feeReceivePlus" },
        width: 150
    }
];

@Component({
    name: "SiteList",
    components: {
        SiteExcel,
        UploadDocument,
        PartnerSelector,
        EmployeeSelector,
        PostOfficeSelector,
        // WardSelector,
        DistrictSelector,
        ProvinceSelector,
        CountrySelector,
        CountryLabel,
        EmployeeLabel,
        PostOfficeLabel,
        // WardLabel,
      DistrictLabel, ProvinceLabel, SiteTableAction, SiteSearch, CommonStatusLabel}
})
export default class extends mixins(CommonMixin) {
    SiteTargetType = SiteTargetType;
    columns = columns;
    EmployeeType = EmployeeType;
    PartnerType = PartnerType;
    visibleUploadSite = false;
    filePathSite = "";
    exporting = false;

    dataSiteExcel = [] as any;
    visibleProgress = false;
    percentLoaded = 0;

    created() {
        SiteStore.updateSiteParams(new SiteParams());
        SiteStore.listSite(new SiteParams());
    }

    get currentPostOfficeRowGuid() {
        return AuthStore.user?.employee?.postOfficeRowGuid
    }

    get sites() {
        return SiteStore.ids.map((id: number) => SiteStore.data[id]);
    }

    get dataSite() {
        return SiteStore.data;
    }

    get cachedDataSite() {
        return SiteStore.cachedDataSite;
    }
    get pagination() {
        return {
            current: SiteStore.meta.page,
            pageSize: SiteStore.meta.limit,
            total: SiteStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} địa danh`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    async save(id: number) {
        const site: Site = this.dataSite[id];
        if (!site) return;
        try {
            site.isSaving = true;
            await SiteStore.updateSite(site);
            site.editable = false;
            this.cachedDataSite[id] = { ...site };
            this.$message.success("Sửa địa danh thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Sửa địa danh thất bại");
        }
        site.isSaving = false;
        return;
    }

    edit(id: number) {
        const site: any = this.dataSite[id];
        if (!site) return;
        site.isSaving = false;
        site.editable = true;
    }

    close(id: number) {
        let site = this.dataSite[id];
        if (!site) return;
        console.log(this.cachedDataSite[id]);
        site = { ...site, ...this.cachedDataSite[id], ['editable']: false };
        this.dataSite[id] = site;
    }

    onChangePage(pagination: any) {
        SiteStore.listSite({...SiteStore.params, page: pagination.current, limit: pagination.pageSize});
    }

    onChangeDeliveryTargetType(id: number) {
        const site = this.dataSite[id];
        if (site.deliveryTargetRowGuid) {
            site.deliveryTargetRowGuid = undefined as any;
        }
    }

    onChangeReceiveTargetType(id: number) {
        const site = this.dataSite[id];
        if (site.receiveTargetRowGuid) {
            site.receiveTargetRowGuid = undefined as any;
        }
    }

    async uploadSite() {
        if (!this.filePathSite) {
            this.$message.error("Chọn file để upload");
            return;
        }
        try {
            const data = {
                filePath: this.filePathSite
            };
            this.$message.warning("Upload địa danh sẽ mất thời gian, vui lòng chờ");
            await uploadSite(data);
            this.visibleUploadSite = false;
            window.location.reload();
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }

    }

    async exportExcel() {
        try {
            this.exporting = true;
            this.visibleProgress = true;
            const { data } = await listSite({ page: 1, limit: 200 });
            this.dataSiteExcel = [];
            this.dataSiteExcel = [...this.dataSiteExcel, ...data.datas];
            for (let i = 2; i <= data.meta?.totalPage; i++) {
                const { data } = await listSite({ page: i, limit: 200 });
                this.dataSiteExcel = [...this.dataSiteExcel, ...data.datas];
                this.percentLoaded = Math.round(i/data.meta?.totalPage * 100);
            }
            setTimeout(() => {
                this.visibleProgress = false;
                const table1 = document.querySelector("#table-excel-site");
                const opt = {
                    raw: true
                };
                const sheet = XLSX.utils.table_to_sheet(table1);
                openDownloadDialog(sheet2blob(sheet, 'Địa danh'), 'Địa Danh.xlsx');
            }, 500)
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        } finally {
            this.exporting = false;
        }
    }
}
